import { useState, useEffect } from 'react';
import { useResponsive, useMediaQuery } from '@edusense/shared-hooks';
import { ScreenCompactMode, BREAKPOINTS } from '../base';

/**
 * 화면 높이를 기반으로 압축 모드를 결정하는 훅
 */
export const useScreenHeight = () => {
  const { screenCompactMode } = useResponsive();
  return { screenCompactMode: screenCompactMode as ScreenCompactMode };
};

/**
 * 모바일 뷰 감지 훅
 */
export const useMobileView = () => {
  return useMediaQuery(`(max-width: ${BREAKPOINTS.mobile}px)`);
};

/**
 * 프로필 메타 스타일 관련 훅
 */
export const useProfileMetaStyles = () => {
  const isMobileView = useMobileView();
  const { screenCompactMode } = useScreenHeight();
  
  const getMetaStyles = () => ({
    fontSize: screenCompactMode === 'minimal' ? '0.75rem' : '0.875rem',
    display: isMobileView && screenCompactMode === 'minimal' ? 'none' : 'block'
  });

  return { getMetaStyles, isMobileView, screenCompactMode };
};